import { saveAs } from 'file-saver';
import { appStore } from '../state/store.js';
import { PDFEngine } from '../pdf/pdfEngine.js';

export class Toolbar {
    constructor() {
        this.btnUndo = document.getElementById('btn-undo');
        this.btnRedo = document.getElementById('btn-redo');
        this.btnExport = document.getElementById('btn-export-pdf');

        this.init();
    }

    init() {
        appStore.subscribe((state, eventType) => {
            if (eventType === 'HISTORY_CHANGED' || eventType === 'PAGES_CHANGED') {
                this.updateButtons();
            }
        });

        this.btnUndo.addEventListener('click', () => {
            appStore.undo();
        });

        this.btnRedo.addEventListener('click', () => {
            appStore.redo();
        });

        this.btnExport.addEventListener('click', async () => {
            await this.handleExport();
        });

        this.updateButtons();
    }

    updateButtons() {
        this.btnUndo.disabled = !appStore.canUndo;
        this.btnRedo.disabled = !appStore.canRedo;
        this.btnExport.disabled = appStore.state.pages.length === 0;
    }

    async handleExport() {
        if (appStore.state.pages.length === 0) return;

        const originalText = this.btnExport.innerText;
        this.btnExport.innerText = 'Exporting...';
        this.btnExport.disabled = true;

        try {
            const pages = appStore.state.pages;
            console.log('[Toolbar] Starting export with pages:', pages);

            const pdfBytes = await PDFEngine.exportPdf(pages);

            console.log('[Toolbar] Received pdfBytes from Engine');
            if (pdfBytes) {
                console.log('[Toolbar] Byte length:', pdfBytes.byteLength);
                if (pdfBytes.length > 10) {
                    const header = new TextDecoder().decode(pdfBytes.slice(0, 8));
                    console.log('[Toolbar] PDF Header check (first 8 bytes):', header);
                }
            }

            // Trigger download with FileSaver
            const blob = new Blob([pdfBytes], { type: 'application/pdf;charset=utf-8' });
            console.log('[Toolbar] Created Blob:', blob);
            saveAs(blob, 'edited.pdf');
            console.log('[Toolbar] Triggered saveAs');

        } catch (err) {
            console.error('Export failed', err);
            alert('Export failed');
        } finally {
            this.btnExport.innerText = originalText;
            this.btnExport.disabled = false;
        }
    }
}
